var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 16.6273C22 19.4173 19.76 21.6773 16.97 21.6873H16.96H7.05C4.27 21.6873 2 19.4373 2 16.6473V16.6373C2 16.6373 2.006 12.2113 2.014 9.98526C2.015 9.56726 2.495 9.33326 2.822 9.59326C5.198 11.4783 9.447 14.9153 9.5 14.9603C10.21 15.5293 11.11 15.8503 12.03 15.8503C12.95 15.8503 13.85 15.5293 14.56 14.9493C14.613 14.9143 18.767 11.5803 21.179 9.66426C21.507 9.40326 21.989 9.63726 21.99 10.0543C22 12.2633 22 16.6273 22 16.6273Z",
    fill: "#0B7077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4761 6.36077C20.6101 4.72877 18.9061 3.68677 17.0301 3.68677H7.05013C5.17413 3.68677 3.47013 4.72877 2.60413 6.36077C2.41013 6.72577 2.50213 7.18077 2.82513 7.43877L10.2501 13.3778C10.7701 13.7978 11.4001 14.0068 12.0301 14.0068C12.0341 14.0068 12.0371 14.0068 12.0401 14.0068C12.0431 14.0068 12.0471 14.0068 12.0501 14.0068C12.6801 14.0068 13.3101 13.7978 13.8301 13.3778L21.2551 7.43877C21.5781 7.18077 21.6701 6.72577 21.4761 6.36077Z",
    fill: "#0B7077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.1ab9192720a63eb709cf67247cf45e63.svg";
export { ForwardRef as ReactComponent };